import { locationValidate } from "../../application/dtos/location_validate";

export class locationEntity {
    constructor({ id, name, is_available, warehouse_id, barcode, stacking_level, l_type, is_enabled, bay_id }){
        this.id = id;
        this.name = name;
        this.is_available = is_available;
        this.warehouse_id = warehouse_id;
        this.barcode = barcode;
        this.stacking_level = stacking_level;
        this.l_type = l_type;
        this.is_enabled = is_enabled;
        this.bay_id = bay_id;
    }

    isValid() {
        return locationValidate(this);
    }
}